export const SET_WALLET_ADDRESS = "SET_WALLET_ADDRESS";
export const SET_TOKEN = "SET_TOKEN";
export const SET_NETWORK = "SET_NETWORK";
export const SET_WALLET_INFO = "SET_WALLET_INFO";
export const SET_isOperator = "SET_isOperator";
export const SET_isAdmin = "SET_isAdmin";
